<template>
  <div>
    <div class="text-center mt-2 title-font" v-if="change !== 'CURRENT'">
      <div class="mb-2" v-if="!scheduled">
        <span v-if="!changeCost && change === 'UPGRADE'" class="mr-2">
          <v-progress-circular indeterminate size="12" width="2" />
        </span>
        <!-- <LoadingSpinner v-if="!changeCost && change === 'UPGRADE'" /> -->
        <span
          class="pricing-card-price"
          v-if="changeCost && change === 'UPGRADE'"
        >
          {{ changeCost }}
        </span>
        <span class="pricing-card-price" v-if="change === 'DOWNGRADE'">
          $0
        </span>
        <span> today </span>
      </div>
      <div class="mb-2">
        <span class="pricing-card-price" v-if="scheduled"> SCHEDULED </span>
      </div>
      <div>
        <span v-if="!scheduled"> then </span>
        <span v-if="subscriptionCost === null" class="mr-2">
          <v-progress-circular indeterminate size="12" width="2" />
        </span>
        <span class="black--text font-weight-bold" style="font-size: 16px">
          {{ subscriptionCost }}
        </span>
        <span v-if="pricing.renewal_frequency === 'monthly'">/month </span>
        <span v-if="pricing.renewal_frequency === 'yearly'">/year </span>
      </div>
    </div>
    <div class="ma-3">
      <v-btn
        v-if="change !== 'CURRENT'"
        :class="[scheduled ? 'btn-primary-light' : 'btn-primary', 'rounded-10']"
        block
        large
        text
        @click="$emit('selection')"
        :disabled="loading"
        :loading="loading"
      >
        {{ scheduled ? "CANCEL" : null }}
        {{ change }}
      </v-btn>
      <div
        v-if="change === 'CURRENT'"
        class="elevation-0 title-font text-center d-flex align-center flex-column justify-start"
        style="text-transform: uppercase; height: 100px"
        disabled
      >
        <span> Your </span>
        <span class="black--text my-2 font-weight-bold" style="font-size: 28px">
          Current
        </span>
        <span> Subscription </span>
      </div>
      <div class="text-center title-font" v-if="change === 'CURRENT'">
        <span v-if="subscriptionCost === null" class="mr-2">
          <v-progress-circular indeterminate size="12" width="2" />
        </span>
        <span class="black--text font-weight-bold" style="font-size: 16px">
          {{ subscriptionCost }}
        </span>
        <span v-if="pricing.renewal_frequency === 'monthly'">/month </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { formatStripeAmount } from "@/utils"
import client from "@/lib/ApiClient"

export default {
  props: ["pricing", "tax", "change", "loading"],

  data() {
    return {
      changeCost: null,
      subscriptionCost: null
    }
  },

  computed: {
    ...mapGetters(["subscriptionSchedule", "subscription", "plans"]),

    scheduled() {
      return this.pricing.code === this.subscriptionSchedule
    }
  },

  methods: {
    async fetchChangeCost() {
      let response = null
      if (this.change === "CURRENT") {
        response = await client.gateway.billing.previewUpcomingInvoice()

        this.subscriptionCost = formatStripeAmount(
          response.total_excluding_tax + response.tax
        )

        return
      }

      response = await client.gateway.billing.previewChangeSubscription({
        plan_code: this.pricing.code,
        schedule: this.change === "UPGRADE" ? false : true
      })

      if (response) {
        this.changeCost = formatStripeAmount(
          response.change_total_excluding_tax + response.change_tax
        )

        this.subscriptionCost = formatStripeAmount(
          response.subscription_total_excluding_tax + response.subscription_tax
        )
      }
    }
  },

  mounted() {
    this.fetchChangeCost()
  }
}
</script>
